// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__3yr6j","label":"LabeledBox_label__2Ha5W"};